import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import { CtaBanner } from '~/components/sections';
import { AboutHero } from '~/components/sections/AboutHero';
import { AboutIntro } from '~/components/sections/AboutIntro';
import { AboutCareersCta, AboutMeetTeam } from '~/components/sections/AboutMeetTeam';
import { aboutMeta } from '~/content/about';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/about')({
  head: () =>
    pageHeadMeta({
      title: aboutMeta.title,
      description: aboutMeta.description,
      path: '/about',
    }),
  component: AboutPage,
});

export function AboutPage() {
  return (
    <PageShell>
      <AboutHero />
      <AboutIntro />
      <AboutMeetTeam />
      <AboutCareersCta />
      <CtaBanner />
    </PageShell>
  );
}
